import 'wretch';
import 'wretch/addons/queryString';
import '../../../utils/mParticle/mParticle.js';
import { parseCookie } from '../../../utils/cookie/cookie.js';

const SEPARTOR = '__';
const PREFIX = `FEATURE${SEPARTOR}`;
const getFeatureFlagsFromCookieString = (cookieString) => {
    const cookies = parseCookie(cookieString);
    return Object.keys(cookies)
        .filter((key) => key.startsWith(PREFIX))
        .reduce((acc, feature) => {
        acc.push({
            name: feature.split(SEPARTOR)[1],
            enabled: cookies[feature] === 'true',
        });
        return acc;
    }, []);
};
const isFeatureEnabled = (featureFlags, flag) => {
    return featureFlags.some((featureFlag) => {
        return featureFlag.name === flag && featureFlag.enabled;
    });
};
const isFeatureEnabledFromCookie = (feature, cookie = document.cookie) => {
    return isFeatureEnabled(getFeatureFlagsFromCookieString(cookie), feature);
};

export { getFeatureFlagsFromCookieString, isFeatureEnabledFromCookie };
//# sourceMappingURL=cookie.js.map
